import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-sm fixed w-full z-10">
      <div className="container mx-auto px-4 py-6 flex justify-between items-center">
        <div className="flex items-center">
          <Link to="/" className="flex items-center">
            <img 
              src="/assets/images/noBgBlueGradient.svg" 
              alt="AiDA Logo" 
              className="h-16 w-auto"
            />
          </Link>
        </div>
        <nav className="hidden md:flex space-x-10 items-center">
          <Link to="/" className="text-gray-700 hover:text-accent-600 transition-colors font-headline text-lg">Home</Link>
          <Link to="/about" className="text-gray-700 hover:text-primary-600 transition-colors font-headline text-lg">About</Link>
          <Link to="/products" className="text-gray-700 hover:text-secondary-600 transition-colors font-headline text-lg">Products</Link>
          <Link to="/blog" className="text-gray-700 hover:text-primary-600 transition-colors font-headline text-lg">Blog</Link>
          <Link to="/contact" className="text-gray-700 hover:text-accent-600 transition-colors font-headline text-lg">Contact</Link>
        </nav>
        <div className="md:hidden">
          <button 
            className="text-gray-700 hover:text-accent-600 focus:outline-none"
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? (
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>
        <div className="hidden md:block">
          <Button asChild variant="accent" size="lg">
            <Link to="/contact">
              Get Started
            </Link>
          </Button>
        </div>
      </div>
      
      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <nav className="container mx-auto px-4 py-4 flex flex-col space-y-4">
            <Link 
              to="/" 
              className="text-gray-700 hover:text-accent-600 transition-colors font-headline text-lg py-2"
              onClick={closeMenu}
            >
              Home
            </Link>
            <Link 
              to="/about" 
              className="text-gray-700 hover:text-primary-600 transition-colors font-headline text-lg py-2"
              onClick={closeMenu}
            >
              About
            </Link>
            <Link
              to="/products"
              className="text-gray-700 hover:text-secondary-600 transition-colors font-headline text-lg py-2"
              onClick={closeMenu}
            >
              Products
            </Link>
            <Link
              to="/blog"
              className="text-gray-700 hover:text-primary-600 transition-colors font-headline text-lg py-2"
              onClick={closeMenu}
            >
              Blog
            </Link>
            <Link
              to="/contact"
              className="text-gray-700 hover:text-accent-600 transition-colors font-headline text-lg py-2"
              onClick={closeMenu}
            >
              Contact
            </Link>
            <div className="pt-4">
              <Button asChild variant="accent" size="lg" className="w-full">
                <Link to="/contact" onClick={closeMenu}>
                  Get Started
                </Link>
              </Button>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
